import { createSlice, nanoid } from '@reduxjs/toolkit';

const storageKey = 'resturent_iot_rota_v1';

const rotaSections = ['opening', 'closing'];
// const rotaSections = ['opening', 'closing', 'cleaning', 'food-temperature', 'pat', 'pest-control'];

const fallbackState = {
  opening: [],
  closing: [],
  cleaning: [],
  'food-temperature': [],
  pat: [],
  'pest-control': [],
};

function normalizeSection(section) {
  return Array.isArray(section) ? section : [];
}

function loadState() {
  if (typeof window === 'undefined') return fallbackState;
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return fallbackState;
    const parsed = JSON.parse(raw);
    return {
      opening: normalizeSection(parsed.opening),
      closing: normalizeSection(parsed.closing),
      cleaning: normalizeSection(parsed.cleaning),
      'food-temperature': normalizeSection(parsed['food-temperature']),
      pat: normalizeSection(parsed.pat),
      'pest-control': normalizeSection(parsed['pest-control']),
    };
  } catch {
    return fallbackState;
  }
}

function saveState(state) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(storageKey, JSON.stringify(state));
}

const initialState = loadState();

const rotaSlice = createSlice({
  name: 'rota',
  initialState,
  reducers: {
    addRota: {
      reducer(state, action) {
        const { section, rota } = action.payload;
        state[section].unshift(rota);
        saveState(state);
      },
      prepare(section, rota) {
        return { payload: { section, rota: { ...rota, id: nanoid() } } };
      },
    },
    updateRota(state, action) {
      const { section, id, updates } = action.payload;
      const index = state[section].findIndex((item) => item.id === id);
      if (index !== -1) {
        state[section][index] = { ...state[section][index], ...updates };
        saveState(state);
      }
    },
    deleteRota(state, action) {
      const { section, id } = action.payload;
      state[section] = state[section].filter((item) => item.id !== id);
      saveState(state);
    },
  },
});

export const { addRota, updateRota, deleteRota } = rotaSlice.actions;
export const selectRota = (state) => state.rota;
export const rotaCards = [
  {
    key: 'opening',
    title: 'Opening Rota',
    description: 'Assign staff for start-of-day opening duties and readiness tasks.',
    accent: 'from-cyan-500 to-cyan-700',
  },
  {
    key: 'closing',
    title: 'Closing Rota',
    description: 'Plan end-of-day lockup, handover, and close-down duties.',
    accent: 'from-violet-500 to-purple-700',
  }
];
// export const rotaCards = [
//   {
//     key: 'opening',
//     title: 'Opening Rota',
//     description: 'Assign staff for start-of-day opening duties and readiness tasks.',
//     accent: 'from-cyan-500 to-cyan-700',
//   },
//   {
//     key: 'closing',
//     title: 'Closing Rota',
//     description: 'Plan end-of-day lockup, handover, and close-down duties.',
//     accent: 'from-violet-500 to-purple-700',
//   },
//   {
//     key: 'cleaning',
//     title: 'Cleaning Rota',
//     description: 'Schedule sanitation work and hygiene coverage across the month.',
//     accent: 'from-emerald-500 to-teal-700',
//   },
//   {
//     key: 'food-temperature',
//     title: 'Food Temperature Rota',
//     description: 'Assign daily temperature monitoring and record-keeping duties.',
//     accent: 'from-amber-500 to-orange-700',
//   },
//   {
//     key: 'pat',
//     title: 'PAT Rota',
//     description: 'Schedule portable appliance testing checks and follow-up tasks.',
//     accent: 'from-slate-700 to-slate-900',
//   },
//   {
//     key: 'pest-control',
//     title: 'Pest Control Rota',
//     description: 'Plan pest control visits, inspections, and treatment follow-ups.',
//     accent: 'from-amber-500 to-orange-700',
//   },
// ];

export const rotaSectionLabels = Object.fromEntries(
  rotaCards.map((card) => [card.key, card.title]),
);

export const rotaSectionKeys = rotaSections;

export default rotaSlice.reducer;
